
// region JS Imports

// region External Modules
import u from "umbrellajs"
import {
  requestIdleCallback,
  RequestIdleCallbackPayload,
} from "plugins/request-animation-frame-polyfill"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory,
} from "./factory"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--app--current-area-size-unit--selection-menu--navbar-style"

const initAllMatchingElements = (deadline?: RequestIdleCallbackPayload): boolean => {
  return u(`.${CELL_CLASS_NAME}`).nodes.some((el) => {
    if (deadline != null && deadline.timeRemaining() <= 10.0) return true

    Factory.create({
      cell: el,
    })
  })
}

function onLoad() {
  function init_some_matching_elements(deadline: RequestIdleCallbackPayload) {
    const more_work_required = initAllMatchingElements(deadline)
    if (more_work_required) {
      requestIdleCallback(init_some_matching_elements)
    }
  }

  requestIdleCallback(init_some_matching_elements)
}

export default {
  initAllMatchingElements,
}

export {
  onLoad,
}
